import useSWR from 'swr';
import { Link } from 'react-router-dom';
import { Grid, Text, Button } from '@chakra-ui/react';
import getUrlParams from '../../services/getUrlParams';
import baseService from '../../services/base';
import { Resume } from '../../components/Card';
import { backgroundOptions } from '../../assets/new-images/backgrounds';
import Loader from '../../components/Feedback/Loader';
import { MainContent, PageHeaderStructure } from '../../components/Layout';
import { pageHeaderContent } from '../../resources/content';
import { SearchBox } from '../../components/Common';
import { useState, useEffect } from 'react';

export default function Companies() {
 const { companyRegister } = getUrlParams();
 const { data, isLoading } = useSWR(`/company/?cr=${companyRegister}`, fetcher);

 const [companies, setCompanies] = useState(data);

 async function fetcher(url) {
  const response = await baseService.get(url);
  return response?.data;
 }

 useEffect(() => {
  if (!companies) {
    setCompanies(data);
  }

 }, [data, companies])

 if (isLoading) {
  return <Loader />;
 }
 return (
  <MainContent>
   <PageHeaderStructure
    title={pageHeaderContent.companies.title}
    subtitle={pageHeaderContent.companies.subtitle}
   >
    <Button
     variant='primary'
     as={Link}
     to='/registration/company'
     width='230px'
     height='59px'
    >
     Cadastrar Empresa
    </Button>
   </PageHeaderStructure>
   <SearchBox 
    filters={['cnpj', 'name']} 
    placeholder={"company.search"} 
    list={data} 
    setList={setCompanies} 
    />
   <Grid templateColumns='repeat(2, 1fr)' gap='16px' mt='10px'>
    {companies?.length > 0 &&
     companies?.map((value, index) => (
      <Resume
       key={index}
       bg={backgroundOptions[index % backgroundOptions.length]}
       title={value?.name}
       subtitle={value?.cnpj?.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5'
       )}
       link={`/registration/questionnaires/${value?.id_company}`}
       linkLabel='Ver questionários'
      >
       <Button
        as={Link}
        to={`/registration/company?id=${value?.id_company}`}
        variant='outline'
        pos='absolute'
        top='20px'
        right='20px'
        w='110px'
        h='49px'
        border='1px solid #FEFEFE'
        borderRadius='8px'
        _hover={{
         bg: 'none',
        }}
       >
        <Text as='span' lineHeight='normal' color='#F5F5FB'>
         Editar
        </Text>
       </Button>
      </Resume>
     ))}
   </Grid>
  </MainContent>
 );
}
